import React from "react";
import CreateUser from "../Components/Users/CreateUser";

const CreateUserPage = () => {
  return <CreateUser />;
};

export default CreateUserPage;
